import { IFeature } from 'mod/featureV2/interface';

export const picTxtLinkage: IFeature = {
    moduleId: 'picTxtLinkage',
    type: 'picTxtLinkage',
    title: 'picTxtLinkage',
    config: {
        imageWidth: 960,
        imageHeight: 608,
        imagePlacement: 'left',
        canExpand: false,
    },
    list: [
        {
            picUrl: 'asset/width-1920/picture/98dd860b855df2c3c89fa371c1c87fdb.jpg',
            title: `<div style="color: gray; font-size: 40px;">Revolution Smart Grow Box</div>`,
            description: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        },
        {
            picUrl: 'asset/width-1920/picture/c6eb1359d94017f96a6cb4a697d77176.jpg',
            title: 'Ready-to-Grow Kit',
            description: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
            video: {
                videoUrl: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
                videoBackUpUrl: 'file-asset/file/6a850710f4ee9020a478fa0caff005dc.mp4',
                autoPlay: true,
            }
        },
        {
            picUrl: 'asset/width-1920/picture/a447362a2ac3c7ff97b0fde4745e825c.jpg',
            title: 'Intelligent Remote Control',
            description: 'Seamlessly integrate sunlight, air, water, and nutrients. Sustainable and ideal for diverse plants, from seed to harvest.',
        },
    ]
};

export const picTxtLinkage2: IFeature = {
    ...picTxtLinkage,
    moduleId: 'picTxtLinkage2',
    config: {
        ...picTxtLinkage.config,
        imagePlacement: 'right',
        canExpand: true,
    },
};